export const formatValueFromBE = (value: string) => {
  const isOnlyNumber = /^[\d|.]+$/.test(value);
  // Don't format percents, words, and already formatted numbers
  if (isOnlyNumber) {
    const hasDecimal = +value % 1 !== 0;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: hasDecimal ? 2 : 0
    }).format(+value);
  }
  return value;
};
